<navigation></navigation>
<div class="container">
  <div class="row">
    <subscriptions-filter
      class="col-4 col-filter"
      [productType]="productType()"
      [collectedTags]="collectedTags()"
      [collectedLocations]="collectedLocations()"
      [(activeFilters)]="activeFilters"
      [(activeTags)]="activeTags"
      [(activeLocations)]="activeLocations"
      [(servicesSearch)]="servicesSearch"
    />
    <subscriptions-results
      class="col-12 col-md-8 col-content"
      [filteredSubscriptionsAugmented]="filteredSubscriptions()"
    />
  </div>
</div>
<div class="container">
  <footer></footer>
</div>
